import axios from 'axios';
import { aicaBaseUrl, cerberusBaseUrl, GET, polusBaseUrl, POST } from '../../utils/axios-interceptor';
import { getTimeStamp } from '../../utils/dateUtils';
import {
    FetchInvestorConfigPayload,
    FetchOrgBasedUsersPayload,
    FetchPortfolioDataPayload,
    GetOwnerDataPayload,
    InitiateReportGenerationPayload,
    InviteCompanyPayload,
    InviteCompanyPayloadV2,
} from './action';
import { EngagementLetterStatus, MonitoringStatus, RiskGrade } from './constants';
import { Option } from '../../modules/Investor/Deals/components/DealsList/DealsTable/components/LenderUsersCell/LenderUsersCell';
import { SortConfig } from '../../utils/constants/commonConstants';
import { cleanCustomFields } from '../../utils/utils';

export function getInvestorConfig(payload: FetchInvestorConfigPayload) {
    return axios({
        url: API_ENDPOINTS.GET_CONFIG,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            orgInfo: {
                accountType: payload.accountType,
                investorOrgId: payload.investorOrgId,
                primaryEmail: payload.primaryEmail,
                assesseeOrgId: payload.assesseeOrgId,
                reportId: payload?.reportId || '',
                configName: payload.configName,
            },
            userRole: payload?.userRole,
        },
    });
}

export function getLenderConfig(payload: FetchInvestorConfigPayload) {
    return axios({
        url: API_ENDPOINTS.GET_CONFIG,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            orgInfo: {
                accountType: payload.accountType,
                investorOrgId: payload.investorOrgId,
                primaryEmail: payload.primaryEmail,
                assesseeOrgId: payload.assesseeOrgId,
                configName: payload.configName,
            },
            userRole: payload?.userRole,
        },
    });
}

export function getPortfolioData(payload: FetchPortfolioDataPayload) {
    let apipayload: { [key: string]: string | number | object } = {
        portfolioTypeToFetch: payload.portfolioTypeToFetch,
        pageNumber: payload.pageNumber,
        companyAccessType: payload.companyAccessType,
        requestId: getTimeStamp(),
    };
    if (payload.partnerUserId) apipayload.partnerUserId = payload.partnerUserId;
    if (payload.filters) apipayload.filters = payload.filters;
    if (payload.sortConfig?.direction) apipayload.sortConfig = payload.sortConfig;

    return axios({
        url: `${API_ENDPOINTS.GET_PORTFOLIO}`,
        method: POST,
        data: apipayload,
        params: {
            ...(payload?.companyName && { companyName: payload.companyName }),
        },
    });
}
export function getPlatformUserDetails(payload: { userId: string }) {
    return axios({
        url: API_ENDPOINTS.GET_PLATFORM_USER_DETAILS,
        method: GET,
        params: {
            userId: payload.userId,
        },
        headers: {
            'x-organization-id': payload.userId,
        },
    });
}

export function getOwnerData(payload: GetOwnerDataPayload) {
    return axios({
        url: API_ENDPOINTS.GET_OWNER_DATA,
        method: GET,
        params: {
            parentOrgId: payload?.investorOrgId,
        },
    });
}

export function getSingleCompanyDetailsService(payload: any) {
    return axios({
        url: API_ENDPOINTS.GET_SINGLE_COMPANY_DATA,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            ...payload,
        },
        headers: {
            'x-organization-id': payload?.assesseeOrgId,
        },
    });
}

export function getCompanyCommentsService(payload: { assesseeOrgId: string; investorOrgId: string }) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_COMPANY_MANDATE_COMMENTS,
        method: POST,
        data: {
            requestPayload: {
                requestId: `FE_COMPANY_COMMENTS_${getTimeStamp()}`,
            },
        },
        headers: {
            ...(payload?.assesseeOrgId && { 'x-requested-organization-id': payload.assesseeOrgId }),
            ...(payload?.investorOrgId && { 'x-organization-id': payload.investorOrgId }),
        },
    });
}

export function initiateReportGenerationService(payload: InitiateReportGenerationPayload) {
    return axios({
        url: API_ENDPOINTS.INITIATE_REPORT_GENERATION,
        method: POST,
        data: {
            assesseeOrgId: payload.assesseeOrgId,
            requestId: getTimeStamp(),
        },
    });
}
export function fetchCityNames() {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_ALL_CITIES,
        method: GET,
    });
}

export function fetchAllUser(payload) {
    return axios({
        url: API_ENDPOINTS.FETCH_ALL_USERS,
        method: 'POST',
        data: {
            pageSize: payload.pageSize,
            pageNumber: payload.pageNumber,
            orgId: payload.orgId,
            userType: payload.userType,
        },
    });
}

export function fetchOrgBasedUsers(payload: FetchOrgBasedUsersPayload) {
    return axios({
        url: API_ENDPOINTS.GET_ORG_BASED_USERS,
        method: 'POST',
        data: {
            pageSize: payload?.pageSize,
            pageNumber: payload?.pageNumber,
            organisationId: payload.orgId,
            userType: payload.userType,
            organisationName: payload?.orgName,
            filters: payload?.filters,
            getPaginatedData: payload?.getPaginatedData,
        },
    });
}

export function getAllInvestmentPreferenceData(payload) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_ALL_INVESTMENT_PREFERENCE_DATA,
        method: POST,
        data: payload,
    });
}

export function getAllInvestmentPreferences(payload: FetchAllInvestmentPreferencesPayload) {
    return axios({
        url: API_ENDPOINTS.GET_ALL_INVESTMENT_PREFERENCES,
        baseURL: polusBaseUrl,
        method: POST,
        data: payload,
    });
}

export function fetchAmlPepData(payload) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_AML_PEP_DATA,
        method: GET,
        params: {
            orgId: payload?.orgId,
            requestId: getTimeStamp(),
        },
    });
}

export const callEditUser = (payload) => {
    return axios({
        url: API_ENDPOINTS.EDIT_USER,
        method: POST,
        data: {
            userId: payload.userId,
            orgInfo: {
                userAdditionalDetails: payload.userAdditionalDetails,
            },
        },
    });
};

export function inviteCompanyService(payload: InviteCompanyPayload) {
    return axios({
        url: API_ENDPOINTS.INVITE_COMPANY,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            orgInfo: {
                ...payload,
            },
        },
    });
}
export function inviteCompanyServiceV2(payload: InviteCompanyPayloadV2) {
    return axios({
        url: `${cerberusBaseUrl}${CERBERUS_ENDPOINTS.INVITE_COMPANY_V2}`,
        method: POST,
        data: payload,
    });
}

export function addToWatchlistService(payload: AddCompanyToWatchlistPayload) {
    return axios({
        url: API_ENDPOINTS.ADD_TO_WATCH,
        method: POST,
        data: {
            orgInfo: {
                ...payload,
            },
        },
    });
}

export function getInvestorAccessTypePermissionsService(payload: InvestorAccessTypePermissionServicePayload) {
    return axios({
        url: API_ENDPOINTS.GET_CONFIG,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            orgInfo: {
                ...payload,
            },
        },
    });
}

export function moveCompanyToNewTierService(payload: AddCompanyToScanPayload) {
    return axios({
        url: API_ENDPOINTS.MOVE_COMPANY_TO_NEW_TIER,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            orgInfo: {
                ...payload,
            },
        },
    });
}

export function inviteCompanyUserService(payload: AddCompanyToScanPayload) {
    return axios({
        url: API_ENDPOINTS.INVITE_COMPANY_USER,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            orgInfo: {
                ...payload,
            },
        },
    });
}

export function updateCompanyService(payload: CompanyUpdatePayload) {
    // Important: avoid mutating the caller's payload since saga uses it to update Redux immediately
    const dataToPost = {
        ...payload,
        companyComment: payload?.companyComment ? { ...payload.companyComment } : undefined,
        customFields: cleanCustomFields(payload?.customFields || {}),
    };

    if (dataToPost?.companyComment?.additionalData) delete dataToPost.companyComment.additionalData;
    return axios({
        url: API_ENDPOINTS.COMPANY_UPDATE,
        method: POST,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        data: dataToPost,
    });
}

export function createDealService(payload: any) {
    return axios({
        url: API_ENDPOINTS.CREATE_DEAL,
        baseURL: polusBaseUrl,
        method: POST,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        data: {
            requestPayload: payload,
        },
    });
}

export function createInvestmentPreference(payload: any) {
    return axios({
        url: API_ENDPOINTS.CREATE_INVESTMENT_PREFERENCE,
        baseURL: polusBaseUrl,
        method: POST,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        data: {
            requestPayload: payload,
        },
    });
}

export function getMetricsForDealCreationService(payload: FetchDealMetricsPayload) {
    return axios({
        url: API_ENDPOINTS.METRICS_FOR_DEAL_CREATION,
        baseURL: polusBaseUrl,
        method: POST,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        data: {
            requestPayload: {
                requestId: getTimeStamp(),
                ...payload,
            },
        },
    });
}

export function getPecMatchingDataService(payload: any) {
    return axios({
        url: API_ENDPOINTS.PEC_MATCHING,
        baseURL: polusBaseUrl,
        method: POST,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        data: {
            requestPayload: payload,
        },
    });
}

export function getAllDealsService(payload: FetchDealsPayload) {
    return axios({
        url: API_ENDPOINTS.GET_ALL_DEALS,
        baseURL: polusBaseUrl,
        method: POST,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        data: {
            requestPayload: payload,
        },
    });
}

export function getAllCompanyDealsService(payload: FetchDealsPayload) {
    return axios({
        url: API_ENDPOINTS.GET_ALL_COMPANY_DEALS,
        baseURL: polusBaseUrl,
        method: POST,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        data: {
            requestPayload: payload,
        },
    });
}

export function getAllLenderDealsService(payload: FetchLenderDealsPayload) {
    return axios({
        url: API_ENDPOINTS.GET_ALL_LENDER_DEALS,
        baseURL: polusBaseUrl,
        method: POST,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        data: {
            requestPayload: payload,
        },
    });
}

export function getSpecificLenderDealsService(payload: FetchLenderDealsPayload) {
    return axios({
        url: API_ENDPOINTS.GET_SPECIFIC_LENDER_DEALS,
        baseURL: polusBaseUrl,
        method: POST,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        data: {
            requestPayload: payload,
        },
    });
}

export function getInvestmentPreference(investmentPreferenceId: string) {
    return axios({
        url: API_ENDPOINTS.GET_INVESTMENT_PREFERENCE,
        baseURL: polusBaseUrl,
        method: GET,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        params: {
            investmentPreferenceId,
        },
    });
}

export function updateInvestmentPreference(payload: any) {
    return axios({
        url: API_ENDPOINTS.UPDATE_INVESTMENT_PREFERENCE,
        baseURL: polusBaseUrl,
        method: POST,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        data: {
            requestPayload: payload,
        },
    });
}

export function updateDealService(payload: DealUpdatePayload) {
    const dataToPost = {
        ...payload,
        comment: payload?.comment ? { ...payload.comment } : undefined,
        customFields: cleanCustomFields(payload?.customFields || {}),
    };
    if (dataToPost?.comment?.additionalData) delete dataToPost.comment.additionalData;
    return axios({
        url: API_ENDPOINTS.DEAL_UPDATE,
        baseURL: polusBaseUrl,
        method: POST,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        data: {
            requestPayload: dataToPost,
        },
    });
}

export function updateInvestorDealService(payload: InvestorDealUpdatePayload) {
    let dataToPost = JSON.parse(JSON.stringify(payload));
    if (dataToPost?.comment?.additionalData) delete dataToPost.comment.additionalData;
    return axios({
        url: API_ENDPOINTS.INVESTOR_DEAL_UPDATE,
        baseURL: polusBaseUrl,
        method: POST,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        data: {
            requestPayload: {
                dealId: payload.investorDealId,
                dealStatus: payload.dealStatus,
                lastUpdatedBy: payload.lastUpdatedBy,
                comment: dataToPost.comment,
                owner: payload.owner,
                userId: payload.userId,
                dealTerms: payload.dealTerms,
                customFields: cleanCustomFields(payload?.customFields || {}),
                owners: payload.owners,
            },
        },
    });
}

export function unlockAicaForCompanyService(payload: UnlockAICAReportPayload) {
    return axios({
        url: API_ENDPOINTS.UNLOCK_AICA,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            orgInfo: {
                ...payload,
            },
            tabs: payload.tabs,
        },
    });
}

export function getDealDataService(payload: { dealId: string; dealBeneficiaryId?: string }) {
    return axios({
        url: API_ENDPOINTS.GET_DEAL_DATA,
        baseURL: polusBaseUrl,
        method: GET,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        params: {
            dealId: payload?.dealId,
            dealBeneficiaryId: payload?.dealBeneficiaryId,
        },
    });
}

export function getLenderDealDataService(payload: { dealId: string }) {
    return axios({
        url: API_ENDPOINTS.GET_LENDER_DEAL_DATA,
        baseURL: polusBaseUrl,
        method: GET,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        params: {
            dealId: payload.dealId,
        },
    });
}

export function getOnePagerDataService(payload) {
    return axios({
        url: API_ENDPOINTS.GET_ONE_PAGER_DATA,
        baseURL: polusBaseUrl,
        method: POST,
        data: {
            requestPayload: {
                requestId: getTimeStamp(),
                ...payload,
                source: 'AICA_ONE_PAGER',
                moduleId: 'ONE_PAGER_OVERVIEW',
            },
        },
    });
}

export function getOnePagerTemplateDataService(payload) {
    return axios({
        url: API_ENDPOINTS.GET_TEMPLATE_ONE_PAGER_FOR_ASSESSEE,
        method: GET,
        params: {
            docType: payload?.docType,
            id: payload?.docId,
        },
        headers: {
            'x-requested-organization-id': payload?.assesseeOrgId,
        },
    });
}

export function getAllOnePagerHistoryService(payload) {
    return axios({
        url: API_ENDPOINTS.GET_ALL_ONE_PAGER_HISTORY,
        method: GET,
        params: {
            docType: payload?.docType,
        },
        headers: {
            'x-requested-organization-id': payload?.assesseeOrgId,
        },
    });
}

export function saveOnePagerTemplateForAssesseeService(payload) {
    return axios({
        url: API_ENDPOINTS.SAVE_TEMPLATE_ONE_PAGER_FOR_ASSESSEE,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            ...payload,
        },
    });
}

// Engagement Letter
export function getEngagementLetterTemplateService(payload) {
    return axios({
        url: API_ENDPOINTS.GET_CONFIG,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            orgInfo: {
                accountType: payload.accountType,
                investorOrgId: payload.pnoId,
                primaryEmail: payload.primaryEmail,
                assesseeOrgId: payload.orgId,
                configName: 'AICA_ENGAGEMENT_LETTER_TEMPLATE',
            },
        },
    });
}

export function getBureauKycConsentTemplateService(payload) {
    return axios({
        url: API_ENDPOINTS.GET_CONFIG,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            orgInfo: {
                accountType: payload.accountType,
                investorOrgId: payload.investorOrgId,
                primaryEmail: payload.primaryEmail,
                assesseeOrgId: payload.assesseeOrgId,
                configName: 'AICA_BUREAU_KYC_CONSENT_TEMPLATE',
            },
        },
    });
}

export function getInvestmentReportService(payload) {
    return axios({
        url: API_ENDPOINTS.GET_INVESTMENT_REPORT,
        method: GET,
        params: {
            requestId: getTimeStamp(),
            assesseeOrgId: payload?.assesseeOrgId,
        },
    });
}

export function getTabLockStatus(payload) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_TAB_LOCK_STATUS,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            ...payload,
        },
        params: {
            assesseeOrgId: payload?.assesseeOrgId,
        },
    });
}

export function fetchAvailableProducts(payload) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_AVAILABLE_PRODUCTS,
        method: POST,
        data: {
            requestPayload: {
                ...payload,
            },
        },
    });
}

export function fetchCompanySector() {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_COMPANY_SECTOR,
        method: GET,
        params: {
            requestId: getTimeStamp(),
        },
    });
}

export function fetchAvailableDebtProducts(payload) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_ALL_PRODUCTS,
        method: GET,
        params: {
            ...payload,
        },
    });
}

export function fetchOrgUser(payload: { orgId: string; accountType: string }) {
    return axios({
        url: API_ENDPOINTS.GET_ORG_USER,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            orgInfo: {
                orgId: payload.orgId,
                accountType: payload.accountType,
            },
        },
    });
}

export function getAllTaskTrackerDataService(payload: { orgId: string }) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_ALL_TASK_TRACKER_DATA,
        method: GET,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
        },
        params: {
            requestId: getTimeStamp(),
            orgId: payload.orgId,
        },
    });
}

export function verifyWebsite(payload) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.VERIFY_WEBSITE,
        method: POST,
        data: {
            requestPayload: {
                requestId: getTimeStamp(),
                ...payload,
            },
        },
    });
}
//# removed params as it as  getting requestid as timestamp which was added in headers
export function fetchOrgInfoService(payload: { orgId: string }) {
    return axios({
        url: API_ENDPOINTS.GET_ORG_INFO,
        method: GET,
        headers: {
            [REQUEST_ID_HEADER]: getTimeStamp(),
            'x-organization-id': payload.orgId,
        },
    });
}

export function pollOnePagerStatusService(payload) {
    return axios({
        url: API_ENDPOINTS.POLL_ONE_PAGER_STATUS,
        method: GET,
        params: {
            orgId: payload.orgId,
            moduleId: 'ONE_PAGER_OVERVIEW',
        },
    });
}

export function invokeOnePagerStateMachineService(payload) {
    return axios({
        url: API_ENDPOINTS.INVOKE_ONE_PAGER_STATE_MACHINE,
        method: POST,
        data: {
            source: 'ONE_PAGER_OVERVIEW',
            requestId: payload.requestId,
            orgId: payload.orgId,
        },
    });
}

export function getMcaDocApiData(payload) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_MCA_API_DATA,
        method: GET,
        params: {
            requestId: getTimeStamp(),
            orgId: payload.orgId,
        },
    });
}

export function getCombinedOrgUsers(payload) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_COMBINED_ORG_USERS,
        method: GET,
        params: {
            companyOrgId: payload.companyOrgId,
            partnerOrgId: payload.partnerOrgId,
        },
    });
}

export function getCombinedDealUsers(payload) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_COMBINED_DEAL_USERS,
        method: GET,
        params: {
            companyOrgId: payload.companyOrgId,
            dealId: payload.dealId,
        },
    });
}

export function sendSystemNotification(payload) {
    return axios({
        baseURL: aicaBaseUrl,
        url: API_ENDPOINTS.SEND_SYSTEM_NOTIFICATION,
        method: POST,
        data: { ...payload },
    });
}

export function getNotificationTemplate(payload) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_NOTIFICATION_TEMPLATE,
        method: GET,
        params: {
            templateId: payload.templateId,
        },
    });
}

export function getFormerEntityName(payload) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_FORMER_ENTITY_NAME,
        method: GET,
        params: {
            organizationId: payload.organizationId,
        },
    });
}

export function getDealsByStatus(payload: { orgId: string; status: string[] }) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_DEALS_BY_STATUS,
        method: POST,
        headers: {
            'x-requested-organization-id': payload?.orgId,
        },
        data: {
            requestPayload: {
                status: payload?.status,
            },
        },
    });
}

export function getMandateQualificationChecks(payload) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_MANDATE_WUALIFICATION_CHECKS,
        method: POST,
        headers: {
            'x-requested-organization-id': payload?.orgId,
            'x-organization-id': payload?.investorOrgId,
        },
        data: {
            requestPayload: {
                requestId: getTimeStamp(),
                dealId: payload.dealId,
            },
        },
    });
}

/**
 * Generates overview data for a company by calling the overview generation API
 * @param payload - The company data required to generate overview
 * @returns Promise with the generated overview data
 */
export const generateOverviewV2 = async (payload: GenerateOverviewRequest) => {
    try {
        const n8nUrl = process.env.REACT_APP_N8N_WEBHOOK_URL_OVERVIEW_V2;
        // const n8nUrl = 'https://n8n.recur.club/webhook-test/generate-aica-overview';
        if (!n8nUrl) {
            throw new Error('Overview V2 webhook URL not configured');
        }

        const response = await axios.post(
            n8nUrl || '',
            {
                data: {
                    legalName: payload.legalName,
                    website: payload.website || '',
                    cin: payload.cin || '',
                    pan: payload.pan || '',
                    orgId: payload.orgId,
                },
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );

        return response.data;
    } catch (error) {
        console.error('Error generating overview:', error);
        throw error;
    }
};

export function editUserV2(payload: EditUserV2Payload) {
    return axios({
        baseURL: aicaBaseUrl,
        url: API_ENDPOINTS.EDIT_USER_V2,
        method: POST,
        data: payload,
    });
}

const API_ENDPOINTS = {
    GET_CONFIG: '/account/config',
    EDIT_USER_V2: '/account/editUserDetails',
    GET_PORTFOLIO: '/portfolio/investor/fetch',
    GET_OWNER_DATA: '/portfolio/getPnoOwners',
    GET_SINGLE_COMPANY_DATA: '/portfolio/assessee/basic/fetch',
    GET_ORG_INFO: '/account/fetch/orgInfo',
    INITIATE_REPORT_GENERATION: '/profile/evaluation/generate',
    INVITE_COMPANY: '/account/org/create',
    COMPANY_UPDATE: '/account/updateOrgMaster',
    CREATE_DEAL: '/unifier/createDeal',
    METRICS_FOR_DEAL_CREATION: '/unifier/getAicaDealMetrics',
    PEC_MATCHING: '/unifier/pecMatching',
    DEAL_UPDATE: '/unifier/updateDeal',
    INVESTOR_DEAL_UPDATE: '/unifier/updateInvestorDeal',
    GET_ALL_DEALS: '/unifier/getAllDeals',
    GET_ALL_COMPANY_DEALS: '/unifier/getAllCompanyDeals',
    GET_ORG_BASED_USERS: '/account/getOrgBasedUsers',
    GET_ALL_LENDER_DEALS: '/unifier/getAllLenderDeals',
    GET_SPECIFIC_LENDER_DEALS: '/unifier/getSpecificLenderDeals',
    GET_INVESTMENT_PREFERENCE: '/unifier/getInvestmentPreference',
    GET_ALL_INVESTMENT_PREFERENCES: '/unifier/getAllInvestmentPreferneces',
    UPDATE_INVESTMENT_PREFERENCE: '/unifier/investmentPreference/update',
    CREATE_INVESTMENT_PREFERENCE: '/unifier/investmentPreference/create',
    GET_DEAL_DATA: '/unifier/getDealData',
    GET_LENDER_DEAL_DATA: '/unifier/getLenderDealData',
    GET_ONE_PAGER_DATA: '/unifier/getAicaOnePagerData',
    GET_INVESTMENT_REPORT: '/investmentReport/download',
    GET_COMBINED_ORG_USERS: '/unifier/getCombinedOrgUsers',
    GET_COMBINED_DEAL_USERS: '/unifier/getCombinedDealUsers',
    GET_DEALS_BY_STATUS: '/unifier/getDealsByStatus',
    GET_COMPANY_MANDATE_COMMENTS: '/unifier/leadComments',
    GET_MANDATE_WUALIFICATION_CHECKS: '/unifier/getMandateQualificationChecks',
    GET_ALL_CITIES: '/unifier/getCitiesList',

    ADD_TO_WATCH: '/account/org/addWatchAccount',
    MOVE_COMPANY_TO_NEW_TIER: '/account/org/moveCompanyToNewTier',
    INVITE_COMPANY_USER: '/account/org/inviteCompanyOrgUser',
    EDIT_USER: '/account/editUser',
    FETCH_ALL_USERS: '/account/getAllUsers',
    UNLOCK_AICA: '/account/unlock',
    GET_TAB_LOCK_STATUS: '/insights/getTabsLockStatus',
    GET_ALL_INVESTMENT_PREFERENCE_DATA: '/unifier/getAllInvestmentPreferenceData',
    GET_AVAILABLE_PRODUCTS: '/unifier/getAvailableProducts',
    GET_ALL_PRODUCTS: '/unifier/getAllProducts',
    GET_COMPANY_SECTOR: '/unifier/getCompanySector',
    GET_ALL_TASK_TRACKER_DATA: '/unifier/getAllTaskTrackerData',
    GET_ORG_USER: '/account/getOrgUser',
    GET_MCA_API_DATA: '/unifier/getMcaDocApiData',
    SEND_SYSTEM_NOTIFICATION: '/dataGap/sendSystemNotification',
    GET_NOTIFICATION_TEMPLATE: '/unifier/getNotificationTemplate',

    // ONE PAGER
    GET_TEMPLATE_ONE_PAGER_FOR_ASSESSEE: '/data/getOnePagerData',
    SAVE_TEMPLATE_ONE_PAGER_FOR_ASSESSEE: '/data/saveOnePagerData',
    GET_ALL_ONE_PAGER_HISTORY: '/data/getAllOnePagerData',
    GET_AML_PEP_DATA: '/unifier/getAmlPepData',
    VERIFY_WEBSITE: '/unifier/websiteVerification',
    POLL_ONE_PAGER_STATUS: '/data/summary/fetch',
    INVOKE_ONE_PAGER_STATE_MACHINE: '/state-machine/invokeModuleSummaryStateMachine',
    GET_FORMER_ENTITY_NAME: '/unifier/getFormerEntityName',
    GET_PLATFORM_USER_DETAILS: '/account/getPlatformUserDetails',
};

const CERBERUS_ENDPOINTS = {
    INVITE_COMPANY_V2: '/v2/access/signUp',
};

const REQUEST_ID_HEADER = 'request-id';

type OwnerType = {
    name: string;
    userId: string;
    activityBy?: string;
    activityDate?: string;
    ownerType?: string;
};

export type AddCompanyToWatchlistPayload = {
    websiteUrl?: string;
    investorOrgId: string;
    journeyName: string;
    inviteCode?: string;
    identifier?: string;
    brandName?: string;
    isPickedFromCompaniesList?: boolean;
    companyDetails?: Record<string, any>;
    // Raw selection from Global Search Add New (for analytics/debug on BE)
    searchResultContext?: Record<string, any>;
};

export type InvestorAccessTypePermissionServicePayload = {
    accountType: string;
    investorOrgId: string;
    primaryEmail: string;
    reportId?: string;
    configName: string;
};

export type AddCompanyToScanPayload = {
    assesseeOrgId: string;
    investorOrgId?: string;
    phoneNumber?: string;
    countryCode?: string;
    countryId?: string;
    primaryEmail?: string;
    inviteType?: string;
    triggerNotification?: boolean;
    primaryUserName?: string;
    websiteUrl?: string;
    pan?: string;
};

export enum CompanyStatus {
    NEW = 'NEW',
    ONGOING = 'ONGOING',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    DEAL_CREATED = 'DEAL_CREATED',
}

export type CompanyUpdatePayload = {
    source?: string | null;
    orgId: string;
    companyStatus?: {
        status?: string;
        userId: string;
        activityDate: number;
    };
    companyRiskGrade?: RiskGrade;
    monitoringStatus?: MonitoringStatus;
    companyComment?: {
        text: string;
        activityBy: string;
        userId?: string;
        activityDate: string;
        additionalData?: Object;
    };
    owner?: OwnerType;
    owners?: OwnerType[];
    engagementLetterStatus?: EngagementLetterStatus;
    customFields?: { [key: string]: any };
};

export type FetchDealMetricsPayload = {
    requestId?: string;
    parentOrgId: string;
    orgId: string;
    startDate: string;
    endDate: string;
};

export type FetchDealsPayload = {
    dealStatuses: string[];
    pageNumber: number;
    pageSize: number;
    ownerUserId: string;
    dealBeneficiaryId?: string;
    sortConfig?: SortConfig;
    filters?: {
        dealBeneficiaryIds?: string[];
    };
};

export type FetchLenderDealsPayload = {
    dealProposerId: string;
    dealStatuses?: string[];
    dealReceiverId?: string;
    pageNumber: number;
    pageSize: number;
    ownerUserId: string;
    sortConfig?: SortConfig;
};

export type DealUpdatePayload = {
    dealId: string;
    dealStatus?: string;
    lastUpdatedBy: string;
    comment?: {
        text: string;
        activityBy: string;
        userId: string;
        activityDate: string;
        additionalData?: any;
    };
    customFields?: { [key: string]: any };
};

export type InvestorDealUpdatePayload = {
    dealId?: string;
    source?: string;
    investorDealId?: string;
    dealStatus?: string;
    lastUpdatedBy: string;
    comment?: {
        text: string;
        activityBy: string;
        userId: string;
        activityDate: string;
        additionalData?: any;
    };
    owner?: OwnerType;
    owners?: OwnerType[];
    userId?: string;
    selectedCategory?: string;
    dealTerms?: {
        [key: string]: any;
    };
    customFields?: { [key: string]: any };
    isLenderSideUsers?: boolean;
    selectedLenderUsers?: string[];
    allUserOptions?: Option[];
};

export type UnlockAICAReportPayload = {
    investorOrgId: string;
    assesseeOrgId: string;
    tabs: string[];
};

export type FetchInvestmentPreferencesPayload = {
    aggregatorId: string;
    lenderIds: string[];
};

export type FetchAllInvestmentPreferencesPayload = {
    requestPayload: {
        aggregatorId: string;
        lenderIds: string[];
        investmentPreferenceType: string;
        investmentPreferenceId: string;
    };
};

export type EditUserV2Payload = {
    userDetails: {
        userId: string;
        name: string;
        emailId: string;
        phoneNumber: string;
        customFields: { [key: string]: any };
    };
    triggerNotification: boolean;
};

export interface GenerateOverviewRequest {
    legalName: string;
    website?: string;
    cin?: string;
    pan?: string;
    orgId: string;
}
